<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<p class="fm01"><span class="bold">Front Cover:</span> 2-BIL at West Worthing in 1966. The ‘1’ head code refers to the Brighton-West Worthing service. (Martin James)</p>
<p class="fm02"><span class="bold">Back Cover:</span> The Southern Electric control room at Woking. (Author)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Fm01.vue?38ae9538